import { render, staticRenderFns } from "./buyed.vue?vue&type=template&id=fb679e38&scoped=true"
import script from "./buyed.vue?vue&type=script&lang=js"
export * from "./buyed.vue?vue&type=script&lang=js"
import style0 from "./buyed.vue?vue&type=style&index=0&id=fb679e38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb679e38",
  null
  
)

export default component.exports